import { useAdoptedTools } from "../../../marketplace";
import { NextSessionCard } from "../../../scheduler";
import type { SubjectKind } from "../../../scheduler";

interface Props {
    kind: SubjectKind;
    id: string;
    label: string;
}

/**
 * The next session booked with this patient, couple or group.
 *
 * Only for therapists who adopted the Scheduler; the check lives here rather
 * than inside the card so the card stays a plain presentation of scheduler
 * data, and so its queries never run for a therapist without the tool.
 *
 * Not week-scoped, unlike the home gadget: "when do I next see them" is a
 * question with no week boundary.
 */
export default function PatientNextSession({ kind, id, label }: Props) {
    const { data: tools, isLoading } = useAdoptedTools();

    if (isLoading || !tools) return null;
    if (!tools.some((tool) => tool.slug === "scheduler")) return null;

    return (
        <NextSessionCard
            // A patient attends couple sessions too. Asking for sessions that
            // are strictly theirs would show "nothing booked" to a therapist
            // whose patient has a couples session on Thursday.
            subject={{ kind: kind === "patient" ? "participant" : kind, id }}
            subjectLabel={label}
            className="glass-effect glass-border border rounded-2xl p-5 shadow-theme-sm"
        />
    );
}
